import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { LINKEDIN_URL } from "@/lib/api";

export function Footer() {
  return (
    <footer className="bg-navy-deep" data-testid="site-footer">
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-display text-lg font-bold text-white">DPO HVAC Mechanical Services</p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            A rapidly growing platform of residential and commercial HVAC, plumbing, and mechanical
            service companies. Great businesses are powered by great people.
          </p>
          <a
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-linkedin-link"
            className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-slate-300 transition-colors hover:text-hydro-glow"
          >
            <Linkedin className="h-4 w-4" /> Follow DPO HVAC on LinkedIn
          </a>
        </div>
        <div className="md:col-span-3">
          <h3 className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-ember-bright">Company</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-300">
            <li><Link to="/about" data-testid="footer-link-about" className="hover:text-white transition-colors">About DPO HVAC</Link></li>
            <li><Link to="/companies" data-testid="footer-link-companies" className="hover:text-white transition-colors">Our Platform Companies</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/accessibility" data-testid="footer-link-accessibility" className="hover:text-white transition-colors">Accessibility Statement</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h3 className="font-mono text-xs uppercase tracking-[0.2em] font-semibold text-ember-bright">Work With Us</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-slate-300">
            <li><Link to="/partner" data-testid="footer-link-partner" className="hover:text-white transition-colors">Why Partner With Us</Link></li>
            <li><Link to="/join" data-testid="footer-link-join" className="hover:text-white transition-colors">Why Join Us</Link></li>
            <li>
              <a
                href="https://www.linkedin.com/company/dpo-hvac/jobs/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-jobs"
                className="hover:text-white transition-colors"
              >
                Open Roles on LinkedIn Jobs
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800/80">
        <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p data-testid="footer-copyright">&copy; {new Date().getFullYear()} DPO HVAC Mechanical Services. All rights reserved.</p>
          <p data-testid="footer-credit">
            Website Designed By{" "}
            <a
              href="https://bp.agency"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-brand-partners-link"
              className="font-bold text-slate-300 hover:text-ember-bright transition-colors"
            >
              Brand Partners
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
